export const PRICING_ROUTE_NAMES = {
  BUYERS_CLUB: 'buyers-club',
  PROMO_CODES: 'promo-codes',
  VOLUME_DISCOUNTS: 'volume-discounts',
  CREATE_VOLUME_DISCOUNT: 'create-volume-discount',
  EDIT_VOLUME_DISCOUNT: 'edit-volume-discount',
  PRICING_CUSTOM_MENUS: 'pricing-custom-menus',
  PRICING_CUSTOM_MENUS_ADD: 'pricing-custom-menus-add',
  PRICING_CUSTOM_MENUS_ADD_NEW: 'pricing-custom-menus-add-new',
  PRICING_CUSTOM_MENUS_EDIT: 'pricing-custom-menus-edit',
  PRICING_CUSTOM_MENUS_EDIT_NEW: 'pricing-custom-menus-edit-new',
};
